import { reducer as firstPurchase } from "./first-purchase/slice";

export const reducer = {
  firstPurchase,
};
